var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3331 15.3331L26.6669 15.3331C27.4041 15.3338 28.0007 14.7371 28 14C28 13.2622 27.4041 12.6662 26.6669 12.6669L15.3331 12.6669V1.33306C15.3331 0.595219 14.7378 6.64889e-07 14 6.64889e-07C13.2629 -0.00072702 12.6662 0.595946 12.6669 1.33306L12.6669 12.6669L1.33306 12.6669C0.595946 12.6662 0 13.2622 0 14C0 14.3682 0.148441 14.7015 0.390021 14.943C0.631601 15.1846 0.965592 15.3338 1.33306 15.3331L12.6669 15.3331L12.6669 26.6669C12.6662 27.0344 12.8154 27.3684 13.057 27.61C13.2985 27.8516 13.6318 28 14 28C14.7378 28 15.3338 27.4041 15.3331 26.6669L15.3331 15.3331Z",
    fill: "#23252E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a90b23be.svg";
export { ForwardRef as ReactComponent };